// Mock data for the luxury beauty salon website

export const heroData = {
  title: "Where Beauty Meets Luxury",
  subtitle: "A sanctuary of aesthetics, skincare, and self-care",
  backgroundImage: "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f",
  ctaText: "Book Your Appointment"
};

export const servicesData = [
  {
    id: 1,
    title: "Facials & Skincare Treatments",
    description: "Rejuvenating treatments for radiant, healthy skin",
    image: "https://images.unsplash.com/photo-1616394584738-fc6e612e71b9",
    icon: "Sparkles",
    featured: true,
    price: "€120 - €200"
  },
  {
    id: 2,
    title: "Injectables & Anti-Aging",
    description: "Professional cosmetic treatments for youthful appearance",
    image: "https://images.unsplash.com/photo-1589710751893-f9a6770ad71b",
    icon: "Zap",
    featured: true,
    price: "€300 - €800"
  },
  {
    id: 3,
    title: "Luxury Hair & Styling",
    description: "Expert hair care and stunning styling services",
    image: "https://images.unsplash.com/photo-1600948836101-f9ffda59d250",
    icon: "Scissors",
    featured: true,
    price: "€90 - €250"
  },
  {
    id: 4,
    title: "Body Treatments",
    description: "Relaxing and therapeutic full-body wellness",
    image: "https://images.unsplash.com/photo-1626383137804-ff908d2753a2",
    icon: "Heart",
    featured: false,
    price: "€150 - €300"
  }
];

export const pricingData = [
  {
    category: "Skincare Treatments",
    services: [
      { name: "Classic European Facial", price: 120 },
      { name: "Anti-Aging Treatment", price: 180 },
      { name: "Deep Cleansing Facial", price: 150 },
      { name: "Hydrating Luxury Facial", price: 200 }
    ]
  },
  {
    category: "Injectable Services",
    services: [
      { name: "Botox Treatment (per area)", price: 300 },
      { name: "Dermal Fillers", price: 500 },
      { name: "Lip Enhancement", price: 400 },
      { name: "Skin Boosters", price: 350 }
    ]
  },
  {
    category: "Hair Services",
    services: [
      { name: "Cut & Blow Dry", price: 90 },
      { name: "Hair Coloring", price: 150 },
      { name: "Balayage/Highlights", price: 220 },
      { name: "Hair Treatments", price: 80 }
    ]
  },
  {
    category: "Body Wellness",
    services: [
      { name: "Full Body Massage", price: 180 },
      { name: "Lymphatic Drainage", price: 200 },
      { name: "Body Contouring", price: 250 },
      { name: "Relaxation Package", price: 300 }
    ]
  }
];

export const galleryData = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f",
    category: "Interior",
    alt: "Elegant salon interior with pink chairs"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1626383137804-ff908d2753a2",
    category: "Interior",
    alt: "Modern salon with professional setup"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1600948836101-f9ffda59d250",
    category: "Interior",
    alt: "Stylish salon with modern design"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1633681926022-84c23e8cb2d6",
    category: "Interior",
    alt: "Clean minimalist salon space"
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1616394584738-fc6e612e71b9",
    category: "Treatments",
    alt: "Luxury facial treatment in progress"
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1589710751893-f9a6770ad71b",
    category: "Treatments",
    alt: "Professional beauty service"
  },
  {
    id: 7,
    image: "https://images.unsplash.com/photo-1607774000480-de3f239fdd4c",
    category: "Tools",
    alt: "High-end beauty tools and brushes"
  },
  {
    id: 8,
    image: "https://images.pexels.com/photos/3992870/pexels-photo-3992870.jpeg",
    category: "Equipment",
    alt: "Professional salon equipment"
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Sarah Johnson",
    text: "I feel radiant after every visit. The attention to detail and luxury experience is unmatched.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face"
  },
  {
    id: 2,
    name: "Emma Thompson",
    text: "The most relaxing and professional salon experience I've ever had. Absolutely transformative.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face"
  },
  {
    id: 3,
    name: "Maria Rodriguez",
    text: "Every treatment exceeds expectations. The staff are true artists in their craft.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face"
  }
];

export const contactData = {
  address: "123 Luxury Avenue, Beauty District, City 12345",
  phone: "+1 (555) 123-4567",
  email: "hello@luxurybeautysalon.com",
  hours: {
    weekdays: "Monday - Friday: 9:00 AM - 7:00 PM",
    saturday: "Saturday: 9:00 AM - 6:00 PM",
    sunday: "Sunday: 10:00 AM - 5:00 PM"
  },
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.0!2d-73.9857!3d40.7488!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDQ0JzU1LjciTiA3M8KwNTknMDguNSJX!5e0!3m2!1sen!2sus!4v1234567890123"
};